import React from "react";

const GoogleMapEmbed = () => {
  return (
    <div className="map-responsive">
      <iframe
        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyC8V96sGgzrasorg2xPOlrlp-cpQFPLSxM&q=slottsgatan%2014%20j%C3%B6nk%C3%B6ping&zoom=10"
        width="600"
        height="450"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Maps view of Slottsgatan 14, Jönköping"
      ></iframe>
    </div>
  );
};

export default GoogleMapEmbed;

//"https://www.google.com/maps/embed/v1/place?key=AIzaSyC8V96sGgzrasorg2xPOlrlp-cpQFPLSxM&q=slottsgatan%2014%20j%C3%B6nk%C3%B6ping&zoom=10"
